module.exports = __webpack_public_path__ + "static/media/data_blue.9772c420.svg";